const useStyles = {
  gpsButton: {
    textTransform: 'none',
    padding: 0,
    minWidth: 'auto',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.5,
  },
  locationIcon: {
    fontSize: 18,
  },
  locationOffIcon: {
    color: 'text.secondary',
    fontSize: 18,
  },
}
export default useStyles
